import { defineComponent as L, withAsyncContext as v, ref as c, computed as r, watch as X, openBlock as f, createElementBlock as g, normalizeClass as h, normalizeStyle as _, createElementVNode as T, renderSlot as M, createTextVNode as C, toDisplayString as x, createCommentVNode as z } from "vue";
import './index.css';function F(t, e, o) {
  let l = (s) => t(s, ...e);
  return o === void 0 ? l : Object.assign(l, { lazy: o, lazyArgs: e });
}
function $(t, e, o) {
  let l = t.length - e.length;
  if (l === 0) return t(...e);
  if (l === 1) return F(t, e, o);
  throw Error("Wrong number of arguments");
}
function w(t) {
  if (typeof t != "object" || !t) return !1;
  let e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
function j(...t) {
  return $(N, t);
}
function N(t, e) {
  let o = { ...t, ...e };
  for (let l in e) {
    if (!(l in t)) continue;
    let { [l]: s } = t;
    if (!w(s)) continue;
    let { [l]: a } = e;
    w(a) && (o[l] = N(s, a));
  }
  return o;
}
const P = /* @__PURE__ */ Object.assign({
  "./default/Cash4Life/config.ts": () => import("./config-BkbmKE0n.js").then((t) => t.default),
  "./default/Cash5/config.ts": () => import("./config-p0IBcUG0.js").then((t) => t.default),
  "./default/LottoAmerica/config.ts": () => import("./config-Dnxbn07G.js").then((t) => t.default),
  "./default/LuckyForLife/config.ts": () => import("./config-D5ON2XKG.js").then((t) => t.default),
  "./default/MegaMillions/config.ts": () => import("./config-CnxAhAnl.js").then((t) => t.default),
  "./default/MillionaireForLife/config.ts": () => import("./config-CC6wQmvO.js").then((t) => t.default),
  "./default/Pick3/config.ts": () => import("./config-CfP9ubUV.js").then((t) => t.default),
  "./default/Pick4/config.ts": () => import("./config-CL5iZaKv.js").then((t) => t.default),
  "./default/Pick6/config.ts": () => import("./config-EiZq-dXZ.js").then((t) => t.default),
  "./default/PowerBall/config.ts": () => import("./config-CRfIDDBU.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/config.ts": () => import("./config-gnyNz8nr.js").then((t) => t.default),
  "./default/TristateMegabucks/config.ts": () => import("./config-DRZWy8Nq.js").then((t) => t.default),
  "./default/TristatePick3/config.ts": () => import("./config-BnpuN9x6.js").then((t) => t.default),
  "./us-ah/MegaMillions/config.ts": () => import("./config-BUetrfcK.js").then((t) => t.default),
  "./us-ah/PowerBall/config.ts": () => import("./config-DsnNPWl9.js").then((t) => t.default),
  "./us-ar/ArkansasCash3/config.ts": () => import("./config-9VhgeqH3.js").then((t) => t.default),
  "./us-ar/ArkansasCash4/config.ts": () => import("./config-BagbeUTb.js").then((t) => t.default),
  "./us-ar/ArkansasLotto/config.ts": () => import("./config-ClWJiTWv.js").then((t) => t.default),
  "./us-ar/ArkansasNaturalStateJackpot/config.ts": () => import("./config-CSLobg4O.js").then((t) => t.default),
  "./us-az/ArizonaFantasy5/config.ts": () => import("./config-DW2xAkzZ.js").then((t) => t.default),
  "./us-az/ArizonaPick3/config.ts": () => import("./config-Ba1mAwtM.js").then((t) => t.default),
  "./us-az/ArizonaPick4/config.ts": () => import("./config-BCL0coNd.js").then((t) => t.default),
  "./us-az/ArizonaThePick/config.ts": () => import("./config-CoLjjchJ.js").then((t) => t.default),
  "./us-az/MegaMillions/config.ts": () => import("./config-B_SgdCcb.js").then((t) => t.default),
  "./us-az/PowerBall/config.ts": () => import("./config-cCnlnmC7.js").then((t) => t.default),
  "./us-co/ColoradoCash5/config.ts": () => import("./config-CHEaAGzN.js").then((t) => t.default),
  "./us-co/ColoradoLotto/config.ts": () => import("./config-Cu176KFv.js").then((t) => t.default),
  "./us-co/ColoradoPick3/config.ts": () => import("./config-I2shOnlA.js").then((t) => t.default),
  "./us-co/LuckyForLife/config.ts": () => import("./config-K5eR1xNV.js").then((t) => t.default),
  "./us-co/MegaMillions/config.ts": () => import("./config-RMzasi6r.js").then((t) => t.default),
  "./us-co/MillionaireForLife/config.ts": () => import("./config-C2HubR-B.js").then((t) => t.default),
  "./us-co/PowerBall/config.ts": () => import("./config-BDJAfj3r.js").then((t) => t.default),
  "./us-fl/FloridaLotto/config.ts": () => import("./config-LF4bI-gF.js").then((t) => t.default),
  "./us-fl/FloridaPick2/config.ts": () => import("./config-Bx-9LUkZ.js").then((t) => t.default),
  "./us-fl/FloridaPick3/config.ts": () => import("./config-DSa4eGlh.js").then((t) => t.default),
  "./us-fl/FloridaPick4/config.ts": () => import("./config-11urUvQg.js").then((t) => t.default),
  "./us-fl/FloridaPick5/config.ts": () => import("./config-5ViJHwpl.js").then((t) => t.default),
  "./us-ma/MassachusettsKeno/config.ts": () => import("./config-D-zkvzPa.js").then((t) => t.default),
  "./us-ma/MassachusettsMassCash/config.ts": () => import("./config-C3a8Ui-1.js").then((t) => t.default),
  "./us-ma/MassachusettsMegabucks/config.ts": () => import("./config-BsOeRzk0.js").then((t) => t.default),
  "./us-ma/MassachusettsTheNumbersGame/config.ts": () => import("./config-IhCGGULV.js").then((t) => t.default),
  "./us-me/TristateGimme5/config.ts": () => import("./config-MSRujMSX.js").then((t) => t.default),
  "./us-me/TristatePick4/config.ts": () => import("./config-BVvUuRaa.js").then((t) => t.default),
  "./us-mn/LottoAmerica/config.ts": () => import("./config-Ah8i9yMc.js").then((t) => t.default),
  "./us-mn/MegaMillions/config.ts": () => import("./config-CZMO2JOZ.js").then((t) => t.default),
  "./us-mn/MinnesotaGopher5/config.ts": () => import("./config-BykkwxV1.js").then((t) => t.default),
  "./us-mn/MinnesotaNorth5/config.ts": () => import("./config-56Coljqa.js").then((t) => t.default),
  "./us-mn/MinnesotaPick3/config.ts": () => import("./config-CF2ohtE-.js").then((t) => t.default),
  "./us-mn/PowerBall/config.ts": () => import("./config-LOdnWAl1.js").then((t) => t.default),
  "./us-ne/NebraskaMyDay/config.ts": () => import("./config-8vP0kNLR.js").then((t) => t.default),
  "./us-ne/NebraskaPick3/config.ts": () => import("./config-B5nmzly4.js").then((t) => t.default),
  "./us-ne/NebraskaPick4/config.ts": () => import("./config-Bv_1N5ML.js").then((t) => t.default),
  "./us-ne/NebraskaPick5/config.ts": () => import("./config-BKDP4vl6.js").then((t) => t.default),
  "./us-nj/Cash5/config.ts": () => import("./config-BdMjJYSl.js").then((t) => t.default),
  "./us-nj/Pick3/config.ts": () => import("./config-BHAo035z.js").then((t) => t.default),
  "./us-nj/Pick4/config.ts": () => import("./config-KW44WFFD.js").then((t) => t.default),
  "./us-nj/Pick6/config.ts": () => import("./config-BKFlhaSd.js").then((t) => t.default),
  "./us-ny/Cash4Life/config.ts": () => import("./config-Btwgjq6p.js").then((t) => t.default),
  "./us-ny/MegaMillions/config.ts": () => import("./config-BoA0xrfX.js").then((t) => t.default),
  "./us-ny/MillionaireForLife/config.ts": () => import("./config-BbLmoZfz.js").then((t) => t.default),
  "./us-ny/NewYorkLotto/config.ts": () => import("./config-fW7BmdR8.js").then((t) => t.default),
  "./us-ny/NewYorkNumbers/config.ts": () => import("./config-CE4iz3zT.js").then((t) => t.default),
  "./us-ny/NewYorkPick10/config.ts": () => import("./config-BK10tJ21.js").then((t) => t.default),
  "./us-ny/NewYorkTake5/config.ts": () => import("./config-CayBAx9i.js").then((t) => t.default),
  "./us-ny/NewYorkWin4/config.ts": () => import("./config-6FMJiqRn.js").then((t) => t.default),
  "./us-ny/PowerBall/config.ts": () => import("./config-kCRYDqYg.js").then((t) => t.default),
  "./us-oh/OhioClassicLotto/config.ts": () => import("./config-uEmxG9zp.js").then((t) => t.default),
  "./us-oh/OhioKeno/config.ts": () => import("./config-CDZn9bZJ.js").then((t) => t.default),
  "./us-oh/OhioPick3/config.ts": () => import("./config-1OhRDRvS.js").then((t) => t.default),
  "./us-oh/OhioPick4/config.ts": () => import("./config-C7BymUk3.js").then((t) => t.default),
  "./us-oh/OhioPick5/config.ts": () => import("./config-DI8345nk.js").then((t) => t.default),
  "./us-oh/OhioRollingCash5/config.ts": () => import("./config-0erI-eGR.js").then((t) => t.default),
  "./us-or/OregonKeno/config.ts": () => import("./config-bEYOxR2N.js").then((t) => t.default),
  "./us-or/OregonLuckyLines/config.ts": () => import("./config-O2QHrWAJ.js").then((t) => t.default),
  "./us-or/OregonMegabucks/config.ts": () => import("./config-Bz4XPYfv.js").then((t) => t.default),
  "./us-or/OregonPick4/config.ts": () => import("./config-qZbKQ-0o.js").then((t) => t.default),
  "./us-pr/PowerBall/config.ts": () => import("./config-CLHq7_HM.js").then((t) => t.default),
  "./us-pr/PuertoRicoLotoCash/config.ts": () => import("./config-CvJrXd7r.js").then((t) => t.default),
  "./us-pr/PuertoRicoPega2/config.ts": () => import("./config-DuKqeJvN.js").then((t) => t.default),
  "./us-pr/PuertoRicoPega3/config.ts": () => import("./config-OcpqFmHL.js").then((t) => t.default),
  "./us-pr/PuertoRicoPega4/config.ts": () => import("./config-B8s6Dp2k.js").then((t) => t.default),
  "./us-tx/LottoTexas/config.ts": () => import("./config-CNlybtPE.js").then((t) => t.default),
  "./us-tx/TexasAllOrNothing/config.ts": () => import("./config-DKeigFrZ.js").then((t) => t.default),
  "./us-tx/TexasCashFive/config.ts": () => import("./config-BuQjFEaN.js").then((t) => t.default),
  "./us-tx/TexasDaily4/config.ts": () => import("./config-Bk6kL23O.js").then((t) => t.default),
  "./us-tx/TexasPick3/config.ts": () => import("./config-BTnwdzOI.js").then((t) => t.default),
  "./us-tx/TexasTwoStep/config.ts": () => import("./config-zes88ZSk.js").then((t) => t.default)
}), O = /* @__PURE__ */ Object.assign({
  "./default/LuckyForLife/logo.svg": () => import("./logo-B4_SdLJD.js").then((t) => t.default),
  "./default/MegaMillions/logo.svg": () => import("./logo-D6dtG6j_.js").then((t) => t.default),
  "./default/MillionaireForLife/logo.svg": () => import("./logo-Dub31H_-.js").then((t) => t.default),
  "./default/PowerBall/logo.svg": () => import("./logo-DcTT_qHx.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/logo.svg": () => import("./logo-C_2W4cqH.js").then((t) => t.default),
  "./us-ar/ArkansasCash3/logo.svg": () => import("./logo-Cseg5SK0.js").then((t) => t.default),
  "./us-ar/ArkansasCash4/logo.svg": () => import("./logo-Dyb3kHWS.js").then((t) => t.default),
  "./us-ar/ArkansasLotto/logo.svg": () => import("./logo-q6Hg56dW.js").then((t) => t.default),
  "./us-ar/ArkansasNaturalStateJackpot/logo.svg": () => import("./logo-BHOs1wJz.js").then((t) => t.default),
  "./us-az/ArizonaFantasy5/logo.svg": () => import("./logo-DNAYuLGO.js").then((t) => t.default),
  "./us-az/ArizonaPick3/logo.svg": () => import("./logo-B6VildXU.js").then((t) => t.default),
  "./us-az/ArizonaPick4/logo.svg": () => import("./logo-1Uc7pnMp.js").then((t) => t.default),
  "./us-az/ArizonaThePick/logo.svg": () => import("./logo-ChXMmt4o.js").then((t) => t.default),
  "./us-co/ColoradoCash5/logo.svg": () => import("./logo-LCgFuV4D.js").then((t) => t.default),
  "./us-co/ColoradoLotto/logo.svg": () => import("./logo-BepNdWQW.js").then((t) => t.default),
  "./us-co/ColoradoPick3/logo.svg": () => import("./logo-Ce_LCrPF.js").then((t) => t.default),
  "./us-co/LuckyForLife/logo.svg": () => import("./logo-DH3GUJQl.js").then((t) => t.default),
  "./us-co/MegaMillions/logo.svg": () => import("./logo-D9kGwTzG.js").then((t) => t.default),
  "./us-co/MillionaireForLife/logo.svg": () => import("./logo-COHP3Tdr.js").then((t) => t.default),
  "./us-co/PowerBall/logo.svg": () => import("./logo-RqOuMT2y.js").then((t) => t.default),
  "./us-fl/Cash4Life/logo.svg": () => import("./logo-CGFCffQn.js").then((t) => t.default),
  "./us-fl/FloridaLotto/logo.svg": () => import("./logo-BKY6QIZ8.js").then((t) => t.default),
  "./us-fl/FloridaPick2/logo.svg": () => import("./logo-DdusRdLz.js").then((t) => t.default),
  "./us-fl/FloridaPick3/logo.svg": () => import("./logo-CJ78OrIt.js").then((t) => t.default),
  "./us-fl/FloridaPick4/logo.svg": () => import("./logo-tplFEbf_.js").then((t) => t.default),
  "./us-fl/FloridaPick5/logo.svg": () => import("./logo-CIOvSff8.js").then((t) => t.default),
  "./us-ma/MassachusettsKeno/logo.svg": () => import("./logo-ifDrSqif.js").then((t) => t.default),
  "./us-ma/MassachusettsMassCash/logo.svg": () => import("./logo-BdnQ1DOm.js").then((t) => t.default),
  "./us-ma/MassachusettsMegabucks/logo.svg": () => import("./logo-mG4G9d8k.js").then((t) => t.default),
  "./us-ma/MassachusettsTheNumbersGame/logo.svg": () => import("./logo-CxIVF_bh.js").then((t) => t.default),
  "./us-me/LottoAmerica/logo.svg": () => import("./logo-CPYBZ_3M.js").then((t) => t.default),
  "./us-me/TristateGimme5/logo.svg": () => import("./logo-C2W9zGRa.js").then((t) => t.default),
  "./us-me/TristateMegabucks/logo.svg": () => import("./logo-DaZ1dmR1.js").then((t) => t.default),
  "./us-me/TristatePick3/logo.svg": () => import("./logo-B65QlWkG.js").then((t) => t.default),
  "./us-me/TristatePick4/logo.svg": () => import("./logo-61rJ-AfO.js").then((t) => t.default),
  "./us-mn/LottoAmerica/logo.svg": () => import("./logo-DeP_kZIT.js").then((t) => t.default),
  "./us-mn/MinnesotaGopher5/logo.svg": () => import("./logo-D_AZVJK5.js").then((t) => t.default),
  "./us-mn/MinnesotaNorth5/logo.svg": () => import("./logo-BynnZUfI.js").then((t) => t.default),
  "./us-mn/MinnesotaPick3/logo.svg": () => import("./logo-DBTq79Gq.js").then((t) => t.default),
  "./us-ne/LottoAmerica/logo.svg": () => import("./logo-DMLQDtmX.js").then((t) => t.default),
  "./us-ne/NebraskaMyDay/logo.svg": () => import("./logo-C_HowF1U.js").then((t) => t.default),
  "./us-ne/NebraskaPick3/logo.svg": () => import("./logo-C5aNtBO0.js").then((t) => t.default),
  "./us-ne/NebraskaPick4/logo.svg": () => import("./logo-4wZ3st8W.js").then((t) => t.default),
  "./us-ne/NebraskaPick5/logo.svg": () => import("./logo-B1HHrOGc.js").then((t) => t.default),
  "./us-nj/Cash4Life/logo.svg": () => import("./logo-zxey6Wb4.js").then((t) => t.default),
  "./us-nj/Cash5/logo.svg": () => import("./logo-Cx0iCxDI.js").then((t) => t.default),
  "./us-nj/Pick3/logo.svg": () => import("./logo-DbPsR7Mg.js").then((t) => t.default),
  "./us-nj/Pick4/logo.svg": () => import("./logo-CxvGyajF.js").then((t) => t.default),
  "./us-nj/Pick6/logo.svg": () => import("./logo-B-XSZPFr.js").then((t) => t.default),
  "./us-ny/Cash4Life/logo.svg": () => import("./logo-CNGF7g0h.js").then((t) => t.default),
  "./us-ny/MegaMillions/logo.svg": () => import("./logo-Da29N7ci.js").then((t) => t.default),
  "./us-ny/MillionaireForLife/logo.svg": () => import("./logo-CrPqG_XB.js").then((t) => t.default),
  "./us-ny/NewYorkLotto/logo.svg": () => import("./logo-D7WCgPEy.js").then((t) => t.default),
  "./us-ny/NewYorkNumbers/logo.svg": () => import("./logo-Bp1AQ2R6.js").then((t) => t.default),
  "./us-ny/NewYorkPick10/logo.svg": () => import("./logo-CFXbDmDR.js").then((t) => t.default),
  "./us-ny/NewYorkTake5/logo.svg": () => import("./logo-6owx68FH.js").then((t) => t.default),
  "./us-ny/NewYorkWin4/logo.svg": () => import("./logo-LMtq7mW2.js").then((t) => t.default),
  "./us-ny/PowerBall/logo.svg": () => import("./logo-BJ29iook.js").then((t) => t.default),
  "./us-oh/OhioClassicLotto/logo.svg": () => import("./logo-BU58iwo0.js").then((t) => t.default),
  "./us-oh/OhioKeno/logo.png": () => import("./logo-842Gt7yz.js").then((t) => t.default),
  "./us-oh/OhioPick3/logo.svg": () => import("./logo-BuPlI56z.js").then((t) => t.default),
  "./us-oh/OhioPick4/logo.svg": () => import("./logo-4sicdUDz.js").then((t) => t.default),
  "./us-oh/OhioPick5/logo.svg": () => import("./logo-BG4F7jia.js").then((t) => t.default),
  "./us-oh/OhioRollingCash5/logo.svg": () => import("./logo-CTYZv6dw.js").then((t) => t.default),
  "./us-or/OregonLuckyLines/logo.svg": () => import("./logo-CsLu1T6p.js").then((t) => t.default),
  "./us-or/OregonMegabucks/logo.svg": () => import("./logo-CGfflNh2.js").then((t) => t.default),
  "./us-or/OregonPick4/logo.svg": () => import("./logo-CxiB83ch.js").then((t) => t.default),
  "./us-pr/PowerBall/logo.svg": () => import("./logo-CJ-QQ_gV.js").then((t) => t.default),
  "./us-pr/PuertoRicoLotoCash/logo.svg": () => import("./logo-PzDPjRDw.js").then((t) => t.default),
  "./us-pr/PuertoRicoPega2/logo.svg": () => import("./logo-BZ1vr8pa.js").then((t) => t.default),
  "./us-pr/PuertoRicoPega3/logo.svg": () => import("./logo-BmBoJ6mV.js").then((t) => t.default),
  "./us-pr/PuertoRicoPega4/logo.svg": () => import("./logo-DQUdTpsK.js").then((t) => t.default),
  "./us-tx/LottoTexas/logo.svg": () => import("./logo-D-mvkvHx.js").then((t) => t.default),
  "./us-tx/MegaMillions/logo.svg": () => import("./logo-CQJF8zr-.js").then((t) => t.default),
  "./us-tx/Powerball/logo.svg": () => import("./logo-C_4C4mrr.js").then((t) => t.default),
  "./us-tx/TexasAllOrNothing/logo.svg": () => import("./logo-D9M8cuto.js").then((t) => t.default),
  "./us-tx/TexasCashFive/logo.svg": () => import("./logo-BaM7NLO9.js").then((t) => t.default),
  "./us-tx/TexasDaily4/logo.svg": () => import("./logo-CUdrdplR.js").then((t) => t.default),
  "./us-tx/TexasPick3/logo.svg": () => import("./logo-C1XECPZp.js").then((t) => t.default),
  "./us-tx/TexasTwoStep/logo.svg": () => import("./logo-Eq9Id0Cf.js").then((t) => t.default)
}), y = ["svg", "png"], I = (t) => typeof t == "function", d = async (t) => t ? I(t) ? await t() ?? null : t ?? null : null, b = async ({ lotteryId: t, licensedTerritory: e }) => {
  const o = await d(
    P[`./${e.toLowerCase()}/${t}/config.ts`]
  );
  let l = null;
  const s = o ? o.extends : t;
  return s && (l = await d(
    P[`./default/${s}/config.ts`]
  )), o && l ? j(l, o) : o ?? l ?? null;
}, k = async ({ lotteryId: t, licensedTerritory: e }) => {
  const o = `./${e.toLowerCase()}/${t}/logo`;
  for (const s of y) {
    const a = await d(O[`${o}.${s}`]);
    if (a) return a;
  }
  const l = `./default/${t}/logo`;
  for (const s of y) {
    const a = await d(O[`${l}.${s}`]);
    if (a) return a;
  }
  return null;
}, G = ["alt", "height", "src"], W = /* @__PURE__ */ L({
  __name: "LcLotteryLogo",
  props: {
    licensedTerritory: {},
    lotteryId: {},
    size: { default: "medium" },
    variant: { default: "only-allowed" }
  },
  async setup(t) {
    let e, o;
    const l = (n) => n !== "text" && !(n === "only-allowed" && !s?.logo), s = ([e, o] = v(() => b({ licensedTerritory: t.licensedTerritory, lotteryId: t.lotteryId })), e = await e, o(), e), a = c(
      l(t.variant) ? ([e, o] = v(() => k({ licensedTerritory: t.licensedTerritory, lotteryId: t.lotteryId })), e = await e, o(), e) : null
    ), i = r(() => [
      "lc-lottery-logo",
      `lc-lottery-logo--size-${t.size}`,
      {
        "lc-lottery-logo--long-name": m.value
      }
    ]), m = r(() => u.value ? u.value.length >= 20 : !1), u = r(() => s?.name), p = r(() => s?.style);
    return X(
      () => t.variant,
      async (n) => {
        if (!l(n)) {
          a.value = null;
          return;
        }
        a.value = await k({ licensedTerritory: t.licensedTerritory, lotteryId: t.lotteryId });
      }
    ), (n, K) => a.value && t.variant !== "text" ? (f(), g("img", {
      key: 0,
      class: h([i.value, "lc-lottery-logo__image"]),
      alt: u.value,
      height: t.size === "large" ? 48 : 36,
      src: a.value
    }, null, 10, G)) : (f(), g("span", {
      key: 1,
      class: h([i.value, "lc-lottery-logo__text"]),
      style: _({
        "--lottery-logo-color": p.value?.highFrequency?.teaser?.logoColor || p.value?.colorPrimary
      })
    }, [
      T("span", null, [
        M(n.$slots, "default", {}, () => [
          C(x(u.value), 1)
        ])
      ])
    ], 6));
  }
}), J = ["all", "only-allowed", "text"], Z = [
  "fluid",
  "large",
  "medium",
  "small"
], A = /* @__PURE__ */ Object.assign({
  "./default/PowerBallXsAndOs/team-logos/ari_color.svg": () => import("./ari_color-Bh1KN1uD.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/ari_white.svg": () => import("./ari_white-C0H_zGBk.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/atl_color.svg": () => import("./atl_color-D6LJpuik.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/atl_white.svg": () => import("./atl_white-D5O218YJ.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/bal_color.svg": () => import("./bal_color-DflXhvDD.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/bal_white.svg": () => import("./bal_white-D1eIb7RD.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/buf_color.svg": () => import("./buf_color-BI5JRH7L.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/buf_white.svg": () => import("./buf_white-BH1jZJ45.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/car_color.svg": () => import("./car_color-BVqNiDyq.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/car_white.svg": () => import("./car_white-BbmHE3fn.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/chi_color.svg": () => import("./chi_color-DQdgEjd-.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/chi_white.svg": () => import("./chi_white-D0I3PN2G.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/cin_color.svg": () => import("./cin_color-CN83cDBM.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/cin_white.svg": () => import("./cin_white-dXwbbdhR.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/cle_color.svg": () => import("./cle_color-DQ4xZHs5.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/cle_white.svg": () => import("./cle_white-Ba5cQNIL.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/dal_color.svg": () => import("./dal_color-DMaoOhrk.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/dal_white.svg": () => import("./dal_white-daSwr0bm.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/den_color.svg": () => import("./den_color-D6946XvL.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/den_white.svg": () => import("./den_white-CyWQ13h9.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/det_color.svg": () => import("./det_color-BIqCLDNz.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/det_white.svg": () => import("./det_white-DORNOg4i.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/gb_color.svg": () => import("./gb_color-I_eYTbjA.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/gb_white.svg": () => import("./gb_white-CPA6KMSL.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/hou_color.svg": () => import("./hou_color-D1-VR8qn.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/hou_white.svg": () => import("./hou_white-D1ajs4cZ.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/ind_color.svg": () => import("./ind_color-DV9ltQqq.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/ind_white.svg": () => import("./ind_white-BTyD7wWE.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/jax_color.svg": () => import("./jax_color-bkDFys5L.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/jax_white.svg": () => import("./jax_white-B41ieU51.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/kc_color.svg": () => import("./kc_color-D9K5iXPa.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/kc_white.svg": () => import("./kc_white-DbiSlTyp.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/lac_color.svg": () => import("./lac_color-nh_92v6B.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/lac_white.svg": () => import("./lac_white-BAr8SVKQ.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/lar_color.svg": () => import("./lar_color-Cq6zR7vu.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/lar_white.svg": () => import("./lar_white-CNrOs63n.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/lv_color.svg": () => import("./lv_color-MKtep5Cc.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/lv_white.svg": () => import("./lv_white-BA4XkLTJ.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/mia_color.svg": () => import("./mia_color-4bL_-pmk.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/mia_white.svg": () => import("./mia_white-BUpCWVYX.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/min_color.svg": () => import("./min_color-CzaNwXI6.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/min_white.svg": () => import("./min_white-CSdoxcHd.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/ne_color.svg": () => import("./ne_color-BWagxEvO.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/ne_white.svg": () => import("./ne_white-CJBl08sn.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/no_color.svg": () => import("./no_color-Yf-XD2Rv.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/no_white.svg": () => import("./no_white-Ce4a0uKV.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/nyg_color.svg": () => import("./nyg_color-C7sDnFfs.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/nyg_white.svg": () => import("./nyg_white-DsnHuEPV.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/nyj_color.svg": () => import("./nyj_color-C1lTc4t2.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/nyj_white.svg": () => import("./nyj_white-BSGa56NW.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/phi_color.svg": () => import("./phi_color-GKBEA_gy.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/phi_white.svg": () => import("./phi_white-BrBTVl_J.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/pit_color.svg": () => import("./pit_color-t7N007tv.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/pit_white.svg": () => import("./pit_white-rqS6Dz3v.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/sea_color.svg": () => import("./sea_color-DnL0LWcY.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/sea_white.svg": () => import("./sea_white-Cbi5_s9x.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/sf_color.svg": () => import("./sf_color-BfQdhBvE.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/sf_white.svg": () => import("./sf_white-bSnL1Es_.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/tb_color.svg": () => import("./tb_color-BKN12aCX.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/tb_white.svg": () => import("./tb_white-DsU8qKSX.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/ten_color.svg": () => import("./ten_color-CZll_Mkg.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/ten_white.svg": () => import("./ten_white-DDh6S_0j.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/was_color.svg": () => import("./was_color-WSQ3FvuJ.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/was_white.svg": () => import("./was_white-B5W9xbpn.js").then((t) => t.default)
}), S = (t) => typeof t == "function", B = async (t) => t ? S(t) ? await t() ?? null : t ?? null : null, E = async ({
  licensedTerritory: t,
  lotteryId: e,
  team: o,
  version: l = "color"
}) => {
  const s = `${o.toLowerCase()}_${l}.svg`, a = `./${t.toLowerCase()}/${e}/team-logos/${s}`, i = await B(A[a]);
  if (i) return i;
  const m = `./default/${e}/team-logos/${s}`;
  return B(A[m]);
}, R = async ({
  licensedTerritory: t,
  lotteryId: e,
  team: o
}) => (await b({ licensedTerritory: t, lotteryId: e }))?.style?.teamColor?.[o.toLowerCase()] ?? null, Y = ["alt", "src"], D = { class: "lc-lottery-team-tile__label" }, q = /* @__PURE__ */ L({
  __name: "LcLotteryTeamTile",
  props: {
    licensedTerritory: {},
    lotteryId: {},
    team: {},
    size: { default: "large" },
    selected: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = c(null), o = c(null), l = r(() => [
      `lc-lottery-team-tile--size-${t.size}`,
      { "lc-lottery-team-tile--selected": t.selected }
    ]);
    return X(
      () => [t.licensedTerritory, t.lotteryId, t.team, t.selected],
      async () => {
        const [s, a] = await Promise.all([
          E({
            licensedTerritory: t.licensedTerritory,
            lotteryId: t.lotteryId,
            team: t.team,
            version: t.selected ? "white" : "color"
          }),
          R({ licensedTerritory: t.licensedTerritory, lotteryId: t.lotteryId, team: t.team })
        ]);
        e.value = s, o.value = a;
      },
      { immediate: !0 }
    ), (s, a) => (f(), g("div", {
      class: h(["lc-lottery-team-tile", l.value]),
      style: _({ "--lc-lottery-team-color": o.value ?? void 0 })
    }, [
      e.value ? (f(), g("img", {
        key: 0,
        class: "lc-lottery-team-tile__logo",
        alt: t.team,
        src: e.value
      }, null, 8, Y)) : z("", !0),
      T("span", D, [
        M(s.$slots, "default", {}, () => [
          C(x(t.team), 1)
        ])
      ])
    ], 6));
  }
}), H = ["color", "white"], Q = ["large", "medium"];
export {
  Z as LC_LOTTERY_LOGO_SIZES,
  J as LC_LOTTERY_LOGO_VARIANTS,
  W as LcLotteryLogo,
  q as LcLotteryTeamTile,
  H as TEAM_LOGO_VERSIONS,
  Q as TEAM_TILE_SIZES,
  R as getTeamColor,
  E as getTeamLogo
};
